import {
    BdsButton,
    BdsButtonGroup,
    BdsFloat,
    BdsFloatAlign,
    BdsIconReplyClockwise,
    BdsIconTrash,
    BdsRollupButton,
} from "@buildertrend/components";

import { type DiscussionCommentEntity } from "commonComponents/entity/comment/CommentContainer/CommentContainer.api.types";
import { Reactions } from "commonComponents/entity/reaction/Reactions";

import { type UserInteractionsContract, UserInteractionsEntityType } from "handlers";

import "./SelectedCommentMenu.less";

interface ISelectedCommentMenuProps {
    comment?: DiscussionCommentEntity;
    onDeleteComment: (comment: DiscussionCommentEntity) => void;
    showCommentInfo: boolean;
    isListItem: boolean;
    reactionData: UserInteractionsContract[];
    onCommentReaction: (commentId: number, data: UserInteractionsContract) => Promise<void>;
    onReplyToComment: () => void;
    isExternal?: boolean;
    anchorRef?: React.RefObject<HTMLDivElement>;
}

function SelectedCommentMenu({
    comment,
    onDeleteComment,
    isListItem,
    onReplyToComment,
    onCommentReaction,
    reactionData,
    isExternal,
    anchorRef,
}: ISelectedCommentMenuProps) {
    if (!comment) {
        return <></>;
    }
    const showReply = (comment?.commentIsJson || comment?.commentText) && !isListItem;

    return (
        <BdsFloat
            source={anchorRef}
            root={`#comment-${comment.id}`}
            align={BdsFloatAlign.MR}
            testid={`comment-menu-${comment.id}`}
            className="comment-menu"
            ariaLabel="More"
            focusOnOpen={false}
            margin={8}
            open
        >
            {isExternal ? (
                <></>
            ) : (
                <Reactions
                    builderId={comment.builderId}
                    entityId={comment.id}
                    entityType={UserInteractionsEntityType.Comments}
                    data={reactionData}
                    onReact={async (reaction) => await onCommentReaction(comment.id, reaction)}
                    hideCounts
                    className="ReactionsMenu"
                />
            )}
            {showReply && !isExternal ? (
                <BdsButton
                    tooltip="Reply"
                    className="CommentReplyButton"
                    tooltipStyle={{ width: "max-content" }}
                    style={{ minWidth: 0, padding: "0 4px" }}
                    displayType="tertiary"
                    testid={`comment-action-bar-reply-${comment.id}`}
                    id={`comment-action-bar-reply-${comment.id}`}
                    ariaLabel="Reply"
                    icon={<BdsIconReplyClockwise />}
                    value="Reply"
                    onClick={onReplyToComment}
                />
            ) : (
                <></>
            )}
            <BdsButtonGroup
                align={BdsFloatAlign.BL}
                grow={false}
                testid={`comment-action-bar-${comment.id}`}
                compact
                root={`#comment-${comment.id}`}
                boundary=".CommentContainer"
                className="comment-action-bar"
                displayType="tertiary"
            >
                {comment.permissions.canDelete && (
                    <BdsRollupButton
                        testid={`comment-action-bar-delete-${comment.id}`}
                        id={`comment-action-bar-delete-${comment.id}`}
                        icon={<BdsIconTrash />}
                        text="Delete"
                        value="Delete"
                        onClick={() => onDeleteComment(comment)}
                        maxStage={0}
                    />
                )}
            </BdsButtonGroup>
        </BdsFloat>
    );
}

export default SelectedCommentMenu;
